import { FieldType } from '@esri/arcgis-rest-request';
import TextCellEditor from './TextCellEditor';
import IntegerCellEditor from './IntegerCellEditor';
import DecimalCellEditor from './DecimalCellEditor';
import { DateCellEditor } from './DateCellEditor';
import { DomainCellEditor } from './DomainCellEditor';

export const EsriTypeEditor: CellEditor<{ type: FieldType }> = ({
  type,
  ...props
}) => {
  if (props.domain?.codedValues) {
    return <DomainCellEditor {...props} />;
  }

  switch (type) {
    case 'esriFieldTypeOID':
    case 'esriFieldTypeSmallInteger':
    case 'esriFieldTypeInteger': {
      return <IntegerCellEditor {...props} />;
    }
    case 'esriFieldTypeSingle':
    case 'esriFieldTypeDouble': {
      return <DecimalCellEditor {...props} />;
    }
    case 'esriFieldTypeDate': {
      return <DateCellEditor {...props} />;
    }
  }
  return <TextCellEditor {...props} />;
};
